import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {List} from 'immutable';

import '../../../../assets/stylesheets/modules/_subheader-dropdown.scss';

export default class SubheaderDropDown extends React.Component {
  static propTypes = {
    options: PropTypes.instanceOf(List),
    selectOptionCallback: PropTypes.func,
    selectedOption: PropTypes.string,
    className: PropTypes.string
  };

  static defaultProps = {
    options: new List(),
    selectOptionCallback: () => {}
  };

  render() {
    const {className, selectedOption, selectOptionCallback, options, optionPath} = this.props;
    const _dropDownClass = classnames('subheader__drop-down', className);

    return (
      <div className={_dropDownClass}>
        <div className='subheader__drop-down-label'>
          {selectedOption}
          <span className='fa fa-chevron-down' />
        </div>
        <div className='subheader__drop-down-list'>
          {options.map((option, index) => {
            const optionDisplay = optionPath ? option.getIn([].concat(optionPath)) : option;

            // Hide selected option from list
            if (optionDisplay === selectedOption) {
              return null;
            }

            return (
              <div
                className='subheader__drop-down-option'
                key={index}
                onClick={() => selectOptionCallback(option, index)}
              >
                {optionDisplay}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
